import { ApolloError, gql, useLazyQuery } from '@apollo/client';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { GetCepCountByMonthAndProductOrTaType } from 'generated/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const GET_ALL_CEPS_COUNT_BY_MONTH_AND_PRODUCT_OR_TA_LAZY = gql`
query GetCustomerEngagementPlanningsCountByMonthAndProductOrTa($filters: DashboardFilter!, $category: String!) {
  getCustomerEngagementPlanningsCountByMonthAndProductOrTa(filters: $filters, category: $category) {
    categoryName
    count
  }
}
`;

type ResultType = {
  getCustomerEngagementPlanningsCountByMonthAndProductOrTa: GetCepCountByMonthAndProductOrTaType[];
};

type UseGetCepsCountByMonthAndProductOrTaLazy = () => {
  getCepsCountByMonthAndProductOrTaLazyQuery: Function;
  loading: boolean;
  error?: ApolloError;
  data: GetCepCountByMonthAndProductOrTaType[];
};

const useGetCepsCountByMonthAndProductOrTaLazyQuery: UseGetCepsCountByMonthAndProductOrTaLazy = () => {
  const [
    getCepsCountByMonthAndProductOrTaLazyQuery,
    { data, loading, error },
  ] = useLazyQuery<ResultType>(GET_ALL_CEPS_COUNT_BY_MONTH_AND_PRODUCT_OR_TA_LAZY, {
    fetchPolicy: 'cache-and-network',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName:
        'GetCepsCountByMonthAndProductOrTaLazy.ts - '
        + 'useGetCepsCountByMonthAndProductOrTaLazyQuery',
    });
  }

  return {
    getCepsCountByMonthAndProductOrTaLazyQuery,
    data: data?.getCustomerEngagementPlanningsCountByMonthAndProductOrTa || [],
    loading,
    error,
  };
};

export default useGetCepsCountByMonthAndProductOrTaLazyQuery;
